export default "__VITE_ASSET__QLDL$xAs__"